export default __webpack_public_path__ + "static/media/object--traffic-cone.b0f05e52.png";